import { BaseError } from './baseError';
export class WordError extends BaseError {
  constructor(e?: string) {
    super(e);
  }
}
